import UrunlerService from "../../../services/UrunlerService";

export default {
  namespaced: true,
  state: () => ({
    ozellikListesi: [],
  }),
  mutations: {
    setOzellikListesi: (state, data) => {
      state.ozellikListesi = data;
    },
  },
  actions: {
    ozellikListesi: ({ commit }) => {
      return new Promise((resolve, reject) => {
        UrunlerService.ozellikListesi()
          .then((res) => {
            commit("setOzellikListesi", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    ozellikEkle: ({ dispatch }, params) => {
      return new Promise((resolve, reject) => {
        UrunlerService.ozellikEkle(params)
          .then((res) => {
            dispatch("ozellikListesi");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    ozellikDuzenle: ({ dispatch }, params) => {
      return new Promise((resolve, reject) => {
        UrunlerService.ozellikDuzenle(params)
          .then((res) => {
            dispatch("ozellikListesi");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    ozellikKaldir: ({ dispatch }, params) => {
      return new Promise((resolve, reject) => {
        UrunlerService.ozellikKaldir(params)
          .then((res) => {
            dispatch("ozellikListesi");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
